import { FilteredLocationList } from "./FilteredLocationList";

export default FilteredLocationList;
